import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial,
} from '../../../St/Reports/UseStyle';
//=====================================================================
import { useTranslation } from "react-i18next";
import { SaleSwitch, useStylesContainers } from '../../../St/comps/UseStyle';
import { ButtonBase, FormControlLabel, Tooltip } from '@material-ui/core';
import { Container, Divider, Input, makeStyles } from "@material-ui/core";
import moment from 'moment';

export default function AnnualSuscriptionForm(props) {

    const {
        AutoOptions,
        changTField,
        params,
        valueAutos,
        changAutos,
        onChangeData,
        onChangeArchive,
        allowArchive
    } = props;

    const clasup = useStylesUp();
    const calsPurch = useStylesAutoPurch();


    const clsConts = useStylesContainers();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();
    const clasTD = useStylesTD();
    const claslbl = useStylesLbl();
    const { t } = useTranslation(["forms", "translation"]);

    return (
        <React.Fragment>
            <Grid container justifyContent="center" spacing={2}>
                <Grid
                    item
                    container
                    spacing={1}
                    lg={12} md={12} sm={12} xs={12}
                >
                    <Grid item lg={6} md={6} sm={6} xs={12}>
                        <Autocomplete
                            classes={clasAo}
                            value={valueAutos.branch}
                            labelPlacement=""
                            onChange={(event, newValue) => {
                                changAutos("branch", newValue);
                            }}
                            id="controllable-states-demo"
                            size="small"
                            options={AutoOptions?.Branches}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            // style={{  }}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t("forms:branch")}
                                    variant="outlined"
                                    size="small"
                                    InputLabelProps={{ className: claslbl.clrBlackLbl }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={12}>

                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={12} style={{ paddingBottom: "0.5rem" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="nameA"

                            label={t("foundation-name-ar")}
                            //className={clasTF.clrBlack}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackTxt, }}
                            // InputProps={{ className: clasTD.input, readOnly: true }}
                            type="text"
                            name="nameA"
                            value={params.nameA}

                            onChange={changTField("nameA")}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={12} style={{ paddingBottom: "0.5rem", direction: "ltr" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="nameE"
                            label={t("foundation-name-en")}
                            type="text"
                            name="nameE"
                            value={params.nameE}
                            InputLabelProps={{
                                className: claslbl.clrBlackLblS,
                            }}
                            InputProps={{ className: claslbl.clrBlackTxt }}
                            onChange={changTField("nameE")}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={12} style={{ paddingBottom: "0.5rem" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="FieldA"
                            label={t("business-activity")}
                            type="text"
                            name="FieldA"
                            value={params.FieldA}
                            InputLabelProps={{
                                className: claslbl.clrBlackLblS,

                            }}
                            InputProps={{ className: claslbl.clrBlackTxt }}
                            onChange={changTField("FieldA")}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={12} style={{ paddingBottom: "0.5rem", direction: "ltr" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="FieldA"
                            label={t("business-activity-en")}
                            type="text"
                            name="FieldA"
                            value={params.FieldE}
                            InputLabelProps={{
                                className: claslbl.clrBlackLblS,

                            }}
                            InputProps={{ className: claslbl.clrBlackTxt }}
                            onChange={changTField("FieldE")}
                        />
                    </Grid>


                    <Grid item lg={4} md={4} sm={6} xs={12} style={{ paddingBottom: "0.5rem" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="bsn_no"
                            label={t("commercial-registration-no")}
                            type="text"
                            name="bsn_no"
                            value={params.bsn_no}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackTxt, }}
                            onChange={changTField("bsn_no")}
                        />
                    </Grid>

                    <Grid item lg={4} md={4} sm={6} xs={12} style={{ paddingBottom: "0.5rem" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="Tel"
                            label={t("phone-number")}
                            type="text"
                            name="Tel"
                            value={params.Tel}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackTxt, }}
                            onChange={changTField("Tel")}
                        />
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12} style={{ paddingBottom: "0.5rem" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="nameEN"
                            label={t("tax-number")}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackTxt, }}
                            type="number"
                            name="tax_no"
                            value={params.tax_no}
                            onChange={changTField("tax_no")}
                        />
                    </Grid>



                    <Container style={{ marginTop: "1rem", marginBottom: "1rem" }}>
                        <Divider style={{ background: "#348781", height: 1.5, }} />
                        <Grid style={{ paddingTop: "0.1cm" }}>
                            <Divider
                                style={{ background: "#348781", height: 1.5 }}
                            />
                        </Grid>

                    </Container>


                    <Grid item lg={6} md={6} sm={6} xs={12} style={{ paddingBottom: "0.5rem" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="datef"
                            label={t("contract-start")}
                            className={clasTF.rootCust}
                            InputProps={{ className: claslbl.clrBlackTxt }}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            type="date"
                            format="YYYY-MM-DD"
                            name="datef"
                            value={params.StartWorkDate}
                            onChange={onChangeData("StartWorkDate")}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={12} style={{ paddingBottom: "0.5rem" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="nameEN"
                            label={t("contract-end")}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackTxt, }}
                            type="date"
                            format="YYYY-MM-DD"
                            name="fromdate"
                            value={params?.EndWorkDate}
                            onChange={onChangeData("EndWorkDate")}
                        />
                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={12} style={{ paddingBottom: "0.5rem" }}>
                                    <FormControlLabel
                                        control={
                                            <Tooltip title="Enable Archiveing System">
                                                <Grid item lg={1} md={1} sm={2} xs={3}>
                                                    <SaleSwitch
                                                        size="small"
                                                        disabled={false}
                                                        checked={allowArchive}
                                                        onChange={onChangeArchive()}
                                                        id="cashORnetworksw"
                                                        value="cashORnetworksw"
                                                        name="cashORnetworksw"
                                                    />
                                                </Grid>
                                            </Tooltip>
                                        }
                                        className={claslbl.clorSw}
                                        label={"Enable Archiveing System"}
                                        labelPlacement="start"
                                    />
                                </Grid>
                </Grid>
                <br />
                <br />
                <br />
                <br />
            </Grid>



        </React.Fragment>
    );

}